import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetchCSBDetails } from '../../actions/additional_actions';
import { FieldLike } from './utils';
import { getDateValue } from '../../utils/date';
import { formatMoney } from '../../utils/budget';

class ReadOnlyCSBDetails extends Component {
    // static PropTypes = {
    //     csbDetail: PropTypes.array.isRequired
    // }

    constructor(props) {
        super(props);
        this.state = {

        }
    }

    UNSAFE_componentWillMount() {
        const { contract } = this.props;
        this.props.fetchCSBDetails(contract.projectId, contract.contractId);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.contract.contractId !== this.props.contract.contractId) {
            this.props.fetchCSBDetails(this.props.contract.projectId, this.props.contract.contractId);

        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.csbDetail !== nextProps.csbDetail)
            this.setState({ csbDetail: nextProps.csbDetail })
        if (this.props.contract.contractId !== nextProps.contract.contractId)
            this.setState({ contract: nextProps.contract })
    }

    render() {
        const { csbDetail } = this.props;
        const { contract } = this.props;

        return (

            <div >
                {csbDetail.length > 0 ?
                    <div className="row static-modal-fields">
                        <div>
                            <div className="col s12 padding-right-0 padding-left-0 margin-top-075">
                                <div className="bar-bottom prjinfo">INFO</div>
                                <div>
                                    <div className="col l4 m3 s6">
                                        <FieldLike label="Registration #" value={csbDetail[0].regNumber} />
                                    </div>
                                    <div className="col l4 m3 s6">
                                        <FieldLike label="Pin #" value={csbDetail[0].pinNumber} />
                                    </div>
                                    <div className="col l4 m3 s12">
                                        <FieldLike label="Vendor Name" value={csbDetail[0].contractor} />
                                    </div>
                                    <div className="col l4 m3 s6">
                                        <FieldLike label="Contract Status" value={csbDetail[0].contractStatus} />
                                    </div>
                                    <div className="col l4 m3 s6">
                                        <FieldLike label="Contract Type" value={csbDetail[0].contractType} />
                                    </div>
                                </div>
                            </div>
                            <div className="col s12 padding-right-0 padding-left-0 margin-top-075">
                                <div className="bar-bottom prjinfo">DATES</div>
                                <div>

                                    <div className="col l4 m3 s6">
                                        <FieldLike label="Contract Start Date" value={getDateValue(csbDetail[0].origContractStartDate)} />
                                    </div>
                                    <div className="col l4 m3 s6">
                                        <FieldLike label="Contract End Date" value={getDateValue(csbDetail[0].origContractCompleteDate)} />
                                    </div>
                                    <div className="col l4 m3 s6">
                                        <FieldLike label="Bid Avertising Date" value={getDateValue(csbDetail[0].cnstrProcBidAdvDt)} />
                                    </div>
                                    {contract.contractType.includes('Construction/') ?
                                        <div>
                                            <div className="col l4 m3 s6">
                                                <FieldLike label="Original Bid Due Date" value={getDateValue(csbDetail[0].cnstrProcOrigBidDt)} />
                                            </div>
                                            <div className="col l4 m3 s6">
                                                <FieldLike label="Amended Bid Due Date" value={getDateValue(csbDetail[0].cnstrProcAmndBidDt)} />
                                            </div>
                                        </div>
                                        : null}
                                    <div className="col l4 m3 s6">
                                        <FieldLike label="Award Date" value={getDateValue(csbDetail[0].awardDate)} />
                                    </div>
                                    <div className="col l4 m3 s6">
                                        <FieldLike label="Pre-Award Date" value={getDateValue(csbDetail[0].preAwardActualEnd)} />
                                    </div>
                                    <div className="col l4 m3 s6">
                                        <FieldLike label="Original NTP Date" value={getDateValue(csbDetail[0].noticeToProceedDate)} />
                                    </div>
                                    {csbDetail[0].divisionName === 'Infrastructure' ? <div className="col l4 m3 s6">
                                        <FieldLike label="Revised NTP Date" value={getDateValue(csbDetail[0].revisedNTPDt)} />
                                    </div> : null}

                                </div>
                            </div>
                            <div className="col s12 padding-right-0 padding-left-0 margin-top-075">
                                <div className="bar-bottom prjinfo">AMOUNT</div>
                                <div>
                                    <div className="col l4 m3 s12">
                                        <FieldLike label="Contract Original Award Amount" value={formatMoney(csbDetail[0].origContractAmount)} />
                                    </div>
                                    <div className="col l4 m3 s6">
                                        <FieldLike label="Current Registered Amount" value={formatMoney(csbDetail[0].current_Registered_Amount)} />
                                    </div>
                                    <div className="col l4 m3 s6">
                                        <FieldLike label="Current Award Amount" value={formatMoney(csbDetail[0].currentContractAmount)} />
                                    </div>
                                    {contract.contractType.includes('Construction/') ?
                                        <div>
                                            <div className="col l4 m3 s6">
                                                <FieldLike label="Estimated Bid Amount" value={formatMoney(csbDetail[0].estimated_Bid_Amount)} />
                                            </div>
                                            <div className="col l4 m3 s6">
                                                <FieldLike label="First Low Bid Amount" value={formatMoney(csbDetail[0].first_Low_Bid_Amount)} />
                                            </div>
                                            <div className="col l4 m3 s6">
                                                <FieldLike label="Second Low Bid Amount" value={formatMoney(csbDetail[0].second_Low_Bid_amount)} />
                                            </div>
                                            <div className="col l4 m3 s6">
                                                <FieldLike label="Bid Amount" value={formatMoney(csbDetail[0].bidAmount)} />
                                            </div>
                                        </div>
                                        : null}


                                </div>
                            </div>

                        </div>
                    </div> : null}
            </div>
        );
    }
}

ReadOnlyCSBDetails.propTypes = {
    csbDetail: PropTypes.array.isRequired
};

function mapStateToProps(state, ownProps) {
    return {
        csbDetail: state.additionalProjectsStore.csbDetail,
        projectId: ownProps.projectId
    };
}

export default connect(mapStateToProps, { fetchCSBDetails })(ReadOnlyCSBDetails);